import { render, staticRenderFns } from "./examination_national_room_list.vue?vue&type=template&id=c8052966&scoped=true"
import script from "./examination_national_room_list.vue?vue&type=script&lang=js"
export * from "./examination_national_room_list.vue?vue&type=script&lang=js"
import style0 from "./examination_national_room_list.vue?vue&type=style&index=0&id=c8052966&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8052966",
  null
  
)

export default component.exports